import React, { useState, useRef, useEffect } from 'react';

interface CursorState {
    left: number;
    top: number;
    isHovered: boolean;
}

const CustomCursor: React.FC = () => {
    const [cursorState, setCursorState] = useState<CursorState>({
        left: 0,
        top: 0,
        isHovered: false,
    });

    const cursorRef = useRef<HTMLDivElement>(null);

    const handleMouseMove = (e: MouseEvent): void => {
        const cursor = cursorRef.current;
        const target = e.target as HTMLElement;

        const newCursorState = {
            left: e.clientX - 10,
            top: e.clientY - 10,
            isHovered: !!target.className.includes('technology-tag')
        };

        setCursorState(newCursorState);

        if (cursor) {
            cursor.style.left = `${newCursorState.left}px`;
            cursor.style.top = `${newCursorState.top}px`;

            if (target.className.includes('technology-tag')) {
                cursor.classList.add('hoveredCursor');
                newCursorState.isHovered = true;
            } else {
                cursor.classList.remove('hoveredCursor');
                newCursorState.isHovered = false;
            }
        }
    };

    const handleMouseLeave = (): void => {
        const cursor = cursorRef.current;
        if (cursor) cursor.style.display = 'none';
    };

    const handleMouseEnter = (): void => {
        const cursor = cursorRef.current;
        if (cursor) cursor.style.display = 'block';
    };

    useEffect(() => {
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseleave', handleMouseLeave);
        document.addEventListener('mouseenter', handleMouseEnter);

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseleave', handleMouseLeave);
            document.removeEventListener('mouseenter', handleMouseEnter);
        };
    }, []);

    return (
        <div
            ref={cursorRef}
            style={{
                position: 'fixed',  // Updated to 'fixed'
                left: cursorState.left,
                top: cursorState.top,
            }}
            className={cursorState.isHovered ? 'hoveredCursor' : ''}
            id="cursor"
        ></div>
    );
};

export default CustomCursor;